let inMemoryAccessToken: string | null = null;

export const saveTokens = ({ accessToken }: { accessToken: string; refreshToken?: string }) => {
  inMemoryAccessToken = accessToken;
};

export const getAccessToken = (): string | null => inMemoryAccessToken;

export const getRefreshToken = (): null => null;

export const clearTokens = () => {
  inMemoryAccessToken = null;
};

export const isAuthenticated = (): boolean => Boolean(inMemoryAccessToken);
